<div
  *ngIf="sectionLoader as activeSectionLoader"
  class="app-section-loader-overlay @container"
>
  <div
    class="app-section-loader-overlay__surface mx-auto flex w-full max-w-xs flex-col items-center gap-3 px-4 py-4 text-center shadow-lg"
    role="status"
    aria-live="polite"
  >
    <mat-spinner diameter="40"></mat-spinner>

    <p *ngIf="activeSectionLoader.message" class="app-section-loader-overlay__message m-0">
      {{ activeSectionLoader.message }}
    </p>
  </div>
</div>
